export const NoSelectedProjectTranslations = {
  en: {
    noSelectedProject: {
      noProjectLabel: "Select a performance to open its sheet.",
    },
  },

  es: {
    noSelectedProject: {
      noProjectLabel: "Selecciona una hoja de performance para abrirla.",
    },
  },
};
